// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CalendarYear_wrapper__YXKIt","year":"CalendarYear_year__wen5R","today":"CalendarYear_today__1xkEN","selected":"CalendarYear_selected__2c1gV"};